import { Table } from '@tiptap/extension-table'

/**
 * Extends the TipTap Table node to support a `data-borderless` attribute.
 * When set, the table renders without visible borders (useful for layout).
 * In the editor, borderless tables show faint dashed guides.
 */
export const BorderlessTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      borderless: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-borderless') === 'true',
        renderHTML: (attributes) => {
          if (!attributes.borderless) return {}
          return { 'data-borderless': 'true' }
        },
      },
    }
  },
})
